let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gCPXI")).then(() => parcelRequire('hW326'));